export * from './filereader'



/** WEBPACK FOOTER **
 ** ./src/utils/filereader/index.js
 **/